/**
 * Minimal fuzzy matcher (Telescope-inspired).
 * Returns true when the query characters appear in order within the text.
 */
export function fuzzyMatch(query, text) {
  const q = query.toLowerCase();
  const t = text.toLowerCase();
  let qi = 0;
  for (let i = 0; i < t.length && qi < q.length; i++) {
    if (t[i] === q[qi]) qi++;
  }
  return qi === q.length;
}